<template>
    <div>
        <Card :padding="0">
            <!--标题-->
            <p slot="title" class="card-title">
                <Icon type="map"></Icon>
                {{chartsTitle}}
            </p>
            <!--查看更多-->
            <a href="#" slot="extra" v-show="isShowMore" @click.prevent="changeLimit">
                <Icon type="ios-loop-strong"></Icon>
                查看更多
            </a>
            <!--图表-->
            <div :style="{height: height}">
                <div style="width:100%;height:100%;" :id="chartsId" v-show="!isShow"></div>
                <div class="chart-error" v-show="isShow">
                    <div class="detail">
                        <span class="detail">暂无数据</span>
                    </div>
                </div>
            </div>
        </Card>
    </div>
</template>

<script>
    export default {
        name: "double-pie-chart",
        props: {
            chartsTitle: String,//图表标题
            chartsId: String,//图表id
            height: String,//卡片高度
            isShowMore: Boolean,//是否展示查看更多
            isShowMoreData: String,//是否展示查看更多
            isClickCharts: Boolean,//是否可以点击柱状图
            smallPieColorArr: Array,
            bigPieColorArr: Array,
            paramPieData: Array,
            isShowTitle: Boolean,//是否显示标题
            // smallPieColorArr: ['#4180FF', '#018AE6', '#03C4B0'],
            // bigPieColorArr: ['#0368E3', '#329ED6', '#26C0E2', '#A0E3BA', '#FFDD84', '#F39C83', '#F36D81', '#E581AD', '#E2BFE9', '#7672ED']
        },
        data () {
            return {
                isShow: false,//默认不展示缺醒图
                defaultPointList: [],
                testData: [
                    {
                        type: 'custom',
                        card_num: 100,
                        obj_subj: {
                            obj_num: 1,
                            subj_num: 2
                        }
                    },
                    {
                        type: 'bank',
                        card_num: 100,
                        obj_subj: {
                            obj_num: 1,
                            subj_num: 2
                        }
                    }
                ]
            }
        },
        watch: {
            'paramPieData': 'initDataSource',
        },
        methods: {
            /**
             *渲染图表
             */
            initDataSource () {
                let _this = this;
                if (this.paramPieData.length > 0) {
                    _this.pieData = _this.copyParamData(this.paramPieData);
                    let dataSourcePie = this.$echarts.init(document.getElementById(this.chartsId));
                    let bigPieColorList = [];
                    let smallPieColorList = [];
                    for (let i = 0; i < _this.pieData.length; i++) {
                        smallPieColorList.push(_this.smallPieColorArr[i]);
                    }
                    for (let i = 0; i < _this.defaultPointList.length; i++) {
                        bigPieColorList.push(_this.bigPieColorArr[i]);
                    }

                    let fontSize = 14;
                    let smallPieRadius = "40%";
                    let bigPieRadiusStart = "55%";
                    let bigPieRadiusEnd = "70%";
                    let smallMinAngle = 5;
                    let bigMinAngle = 10;
                    if (this.screenWidth <= 1680) {
                        fontSize = 9;
                        smallMinAngle = 10;
                        bigMinAngle = 18;
                    }
                    if (this.screenWidth <= 1028) {
                        fontSize = 8;
                        smallMinAngle = 10;
                        bigMinAngle = 18;
                    }

                    const option = {
                        title: {
                            show: this.isShowTitle,
                            text: this.chartsTitle,
                            x: 'center',
                            textStyle: {
                                color: '#708acc',
                                fontSize: 14
                            },
                            top: '0'
                        },
                        tooltip: {
                            trigger: 'item',
                            formatter: "{b}: {c} ({d}%)"
                        },
                        series: [
                            {
                                name: '',
                                type: 'pie',
                                minAngle: smallMinAngle,           　　 //最小的扇区角度（0 ~ 360），用于防止某个值过小导致扇区太小影响交互
                                avoidLabelOverlap: true,   //是否启用防止标签重叠策略
                                selectedMode: 'single',
                                radius: [0, smallPieRadius],
                                center: ['50%', '50%'], // 图的位置
                                label: {
                                    normal: {
                                        position: 'inner',
                                        formatter: "{b}\n{d}%",
                                        fontSize: fontSize
                                    }
                                },
                                labelLine: {
                                    normal: {
                                        show: false
                                    }
                                },
                                data: _this.pieData,
                                color: smallPieColorList
                            },
                            {
                                name: '',
                                type: 'pie',
                                minAngle: bigMinAngle,           　　 //最小的扇区角度（0 ~ 360），用于防止某个值过小导致扇区太小影响交互
                                avoidLabelOverlap: true,   //是否启用防止标签重叠策略
                                radius: [bigPieRadiusStart, bigPieRadiusEnd],
                                center: ['50%', '50%'], // 图的位置
                                label: {
                                    normal: {
                                        formatter: '{b}:{c}',
                                        // formatter: _this.initLabelStr(),//自定义方法
                                        fontSize: fontSize
                                    }
                                },
                                labelLine: {
                                    normal: {
                                        length: 12,
                                        length2: 12
                                    }
                                },
                                data: _this.defaultPointList,
                                color: bigPieColorList
                            }
                        ]
                    };
                    dataSourcePie.clear();
                    dataSourcePie.setOption(option, true);
                    // 处理点击事件
                    dataSourcePie.on('click', function (params) {
                        if (params.seriesIndex == 0) {
                            for (var i = 0; i < option.series[0].data.length; i++) {
                                option.series[0].data[i].selected = false;
                            }
                            option.series[0].data[params.dataIndex].selected = true;
                            option.series[1].data = option.series[0].data[params.dataIndex].pointList;
                            dataSourcePie.clear();
                            dataSourcePie.setOption(option);
                        }
                    });
                    window.addEventListener('resize', function () {
                        dataSourcePie.resize();
                    });
                }
            },
            /**
             * 根据参数数组加载饼状图
             */
            copyParamData (list) {
                let _this = this;
                let _pieData = [];
                _this.defaultPointList = [];
                for (let i = 0; i < list.length; i++) {
                    let pieItemObj = {};
                    pieItemObj.name = list[i].hwtype == 0 ? '自定义作业' : '题库作业';
                    pieItemObj.value = list[i].hw_num;
                    pieItemObj.selected = false;
                    pieItemObj.pointList = [];

                    for (let j = 0; j < 2; j++) {
                        let pointObj = {};
                        pointObj.name = j == 0 ? '主观题数量' : '客观题数量';
                        pointObj.name = pieItemObj.name + '_' + pointObj.name;
                        if (list[i].obj_subj) {
                            pointObj.value = j == 0 ? list[i].obj_subj.subj_num : list[i].obj_subj.obj_num;
                        }
                        pieItemObj.pointList.push(pointObj);
                        _this.defaultPointList.push(pointObj);
                    }
                    _pieData.push(pieItemObj);
                }
                return _pieData;

            },
            initLabelStr (e) {
                var newStr = " ";
                var newStr2 = " ";
                var start, end;
                var name_len = e.name.length;    　　　　　　　　　　　　   //每个内容名称的长度
                var max_name = 8;    　　　　　　　　　　　　　　　　　　//每行最多显示的字数，超过八个字换行处理
                var new_row = Math.ceil(name_len / max_name); 　　　　// 最多能显示几行，向上取整比如2.1就是3行
                if (name_len > max_name) { 　　　　　　　　　　　　　　  //如果长度大于每行最多显示的字数
                    for (var i = 0; i < new_row; i++) { 　　　　　　　　　　　   //循环次数就是行数
                        var old = '';    　　　　　　　　　　　　　　　　    //每次截取的字符
                        start = i * max_name;    　　　　　　　　　　     //截取的起点
                        end = start + max_name;    　　　　　　　　　  //截取的终点
                        if (i == new_row - 1) {    　　　　　　　　　　　　   //最后一行就不换行了
                            old = e.name.substring(start);
                        } else {
                            old = e.name.substring(start, end) + "\n";
                        }
                        newStr += old; //拼接字符串
                    }
                } else {                                          //如果小于每行最多显示的字数就返回原来的字符串
                    newStr = e.name;
                }
                newStr2 += e.percent + "%" + newStr;//添加百分号处理
                return newStr2;
            }
        },
        mounted () {
        }
    }
</script>

<style lang="scss" scoped>

</style>
